module.exports = __webpack_public_path__ + "static/media/haluwa.b637e96b.ogg";